<a aria-label="Read about our work with Homeland Security" [routerLink]="['/safety-act']">
<div class="dhsSection">
  <div class="dhsCopySection">
   <div class="safetyActCertifiedLogo">
      <img loading="lazy" src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2Fsafety_act_certification_200w.png?alt=media&token=62f9f499-f8e0-407c-8c1e-1e7f9e5f0619" alt="Department of Homeland Security Safety Act Certification" />
    </div>
  <div class="dhsSectionTitle">
    <div>
<p>DHS SAFETY ACT</p>
    <p>CERTIFIED</p>
    </div>
       </div>

  <div class="dhsCopy">
    <p>The SAFETY Act offers legal liability protections for companies who develop and deploy qualified anti-terrorism technologies (QATT) that could save lives in the event of an attack.
    </p>
    <p>
      There are three levels of recognition within the SAFETY Act by the DHS: The highest award level, Certification, allows the provider and the customer complete immunity to the extent of “Government Contractor’s Defense” and is not held liable for any claimed failures of technical performance or design in the event of a lawsuit. Contemporary Services Corporation (CSC) is the first to obtain SAFETY Act Designation and Certification for event security services and crowd management by the U.S. Department of Homeland Security. CSC remains the only company in these industries to achieve these awards.
    </p>
    <p>
      CSC is honored to continue to be under the protection of the U.S. Department of Homeland Security SAFETY Act Certification because of what this means for our clients. We look forward to continuing to provide the safest, most secure events and ensuring the future success of our industry.
    </p>
     
    <button mat-raised-button title="Read about our work with Homeland Security" [routerLink]="['/safety-act']" class="cscGoldBtn">Safety Act Certification</button>
    
  </div>
  </div>
</div>
</a>

